jQuery(document).ready(function($) {
    var lazyMasonry = _.debounce(function() {
        activateMasonry();
    }, 400)

    $(window).resize(lazyMasonry)


    var last_used_div = ""


    function activateMasonry() {
        if (window.matchMedia("(min-width: 760px)").matches) {
            $(".masonry_wrapper").masonry()
        }
    }

    activateMasonry()


    if ($(".tooltip")[0]) {
        jQuery(".tooltip").tooltip()
    }

    // check all links to images, except SVGs
    $("a[href$='.jpg']").each(addFancybox)
    $("a[href$='.gif']").each(addFancybox)
    $("a[href$='.jpeg']").each(addFancybox)
    $("a[href$='.webp']").each(addFancybox)

    function addFancybox(index) {
        if ($(this).find("img").length > 0) {
            if (!$(this).data('fancybox')) {
                $(this).attr('data-fancybox', 'gallery')
            }
        }
    }

    if (!$('body').hasClass('home')) {
        $("[data-fancybox]").fancybox({
            prevEffect: "none",
            nextEffect: "none",
            loop: true,
            toolbar: false,
            helpers: {
                title: {
                    type: "inside",
                    buttons: {}
                }
            }
        })
    }

    if (typeof Flickity === "function") {
        $('.slider').flickity({
            arrowShape: {
                x0: 20,
                x1: 59,
                y1: 50,
                x2: 71,
                y2: 39,
                x3: 40
            }
        })
    }
    //if home page is loaded, then the selectboxes needs to reset
    if ($(".selVakstudie").length > 0) {
        $(".selVakstudie")
            .find("option:first")
            .attr("selected", "selected")
        $("#selPracticeProject")
            .find("option:first")
            .attr("selected", "selected")
        $(".clickAndGo")
            .find("option:first")
            .attr("selected", "selected")
    }

    $(".master-overlay_gradient").on("click", function() {
        var height = $(this)
            .parent()
            .children(".inner_preview")
            .height()
        var this_elem = $(this)

        if (height > 400) {
            var this_elem_class = $(this)
                .parent()
                .hasClass("expanded")

            if (this_elem_class) {
                $(this)
                    .parent()
                    .animate({
                        height: "400"
                    })
                $(this)
                    .parent()
                    .removeClass("expanded")
                $(this)
                    .children(".master-vakstudie_expand_post_arrow")
                    .html("&#x25BC; read more &#x25BC;")
            } else {
                $(this)
                    .parent()
                    .animate({
                        height: height
                    })
                $(this)
                    .parent()
                    .addClass("expanded")
                $(this)
                    .children(".master-vakstudie_expand_post_arrow")
                    .html("&#x25B2; collapse &#x25B2;")
            }

            //scroll back to position
            setTimeout(
                function(this_elem) {
                    var offset_top = this_elem.parent().offset().top

                    var moveto = offset_top

                    $("html, body").animate({
                            scrollTop: moveto
                        },
                        500
                    )
                },
                500,
                this_elem
            )
        }
    })

    $(window).on("resize", function() {
        $(".expanded").stop()

        $(".expanded").each(function() {
            var height = $(this)
                .children(".inner_preview")
                .height()

            $(this).animate({
                height: height
            })
        })
    })

    //we should remove the read more button when there is not enough content
    $(".master-block-preview").each(function() {
        var innerheight = $(this)
            .children(".inner_preview")
            .height()

        if (innerheight > 400) {
            $(this)
                .children(".master-overlay_gradient")
                .hide()
        }
    })

    $(".master-post-fader").on("click", function() {
        var background_url = $(this)
            .children(".master-background_image")
            .val()

        if (background_url !== "") {
            if (
                last_used_div === "bg_image_2" &&
                background_url !== $(".bg_image_2").attr("src")
            ) {
                $(".bg_image_1")
                    .attr("src", background_url)
                    .fadeIn("fast", function() {
                        $(".bg_image_2").fadeOut("slow")
                    })
                last_used_div = "bg_image_1"
            } else if (
                last_used_div === "bg_image_1" &&
                background_url !== $(".bg_image_1").attr("src")
            ) {
                $(".bg_image_2")
                    .attr("src", background_url)
                    .fadeIn("fast", function() {
                        $(".bg_image_1").fadeOut("slow")
                    })
                last_used_div = "bg_image_2"
            }
        }
    })

    /**
     * description: fill the vakstudy selectbox with the right content
     */
    $(".selBlog").on("change", function() {
        $(".selVakstudie")
            .not($(this))
            .find("option:first")
            .attr("selected", "selected")

        var study_components_id = $(this).attr("attr-study-component")
        var period_id = $(this).val()
        var vakstudie_quarter_year = $(this)
            .parent()
            .children(".vakstudie_quarter_year")
            .val()
        var data = null
        var this_elem = $(this)

        //reset all other dropdown lists
        resetResultLists(this_elem)

        $.post(
            "wp-content/themes/wdka-master/js/ajax/getStudieRichtingByQuarter.php", {
                period_id: period_id,
                component_id: study_components_id,
                year: vakstudie_quarter_year
            }
        ).done(function(data) {
            if (data !== "") {
                this_elem
                    .parents()
                    .children(".styled-list")
                    .slideUp("fast", function() {
                        $(this)
                            .html(data)
                            .slideDown("slow")
                    })
            }
            //reset masonry framework
            if (window.matchMedia("(min-width: 760px)").matches) {
                resetMasonry(200)
            }
        })
    })

    /**
     * description: fill the practice project
     */
    $("#selPracticeProject").on("change", function() {
        //get required params
        var period_id = $(this).val()
        var practice_project_quarter_year = $(this)
            .parent()
            .children(".practice_project_quarter_year")
            .val()
        var this_elem = $(this)

        //reset all other dropdown lists
        resetResultLists(this_elem)

        $.post(
            "wp-content/themes/wdka-master/js/ajax/getPracticeProjectByQuarter.php", {
                period_id: period_id,
                year: practice_project_quarter_year
            }
        ).done(function(data) {
            if (data !== "") {
                this_elem
                    .parents()
                    .children(".practice_project_quarters_resultlist")
                    .slideUp("fast", function() {
                        $(this)
                            .html(data)
                            .slideDown("slow")
                    })
            }
            //reset masonry framework
            if (window.matchMedia("(min-width: 760px)").matches) {
                resetMasonry(200)
            }
        })
    })

    /**
     * description: used on home, for clicking on the selectboxes of period
     */
    $(".clickAndGo").change(function(event) {
        $("option:selected", $(this)).each(function() {
            var obj = $(this).attr("title")
            document.location.href = obj
        })
    })

    /**
     * description: used on home, for expanding boxes
     */
    $(".hidden_content")
        .parent()
        .parent()
        .on("click", function() {
            $(this)
                .children()
                .children(".hidden_content")
                .slideDown()

            //reset masonry framework
            if (window.matchMedia("(min-width: 760px)").matches) {
                resetMasonry(0)
            }
        })


    $("#master-bloginfo-wrap").on("click", function() {
        document.location.href = url
    })



    /**
     * description: initialise masonry plugin, for dynamic div blocks (on home)
     */
    function resetMasonry(time_interval) {
        setTimeout(function() {
            $(".masonry_wrapper")
                .masonry("reloadItems")
        }, time_interval)
    }

    /**
     * description: reset the home dropdowns of the homescreen
     */
    function resetResultLists(this_elem) {
        //slide up
        $(".styled-list").slideUp()

        //reset the fields
        $(".selBlog")
            .not(this_elem)
            .find("option:first")
            .attr("selected", "selected")
    }

    /**
     * description: magnify glass on images, and do the fading
     */
    $(document).on(
        "hover",
        ".image_fader * img[class*=' wp-image'], img[class*=' wp-image'], .image_fader * img[class*=' wp-post-image']",
        function() {
            $(this)
                .parent()
                .children(".magnify")
                .fadeToggle(250)
        }
    )



    /**
     * description: initialise slider
     */
    function init_slider() {
        $(".slider_container_wrapper > .slider_container").ready(function() {
            var _CaptionTransitions = []
            _CaptionTransitions["L"] = {
                $Duration: 800,
                x: 0.6,
                $Easing: {
                    $Left: $JssorEasing$.$EaseInOutSine
                },
                $Opacity: 2
            }

            var options = {
                $DragOrientation: 3, //[Optional] Orientation to drag slide, 0 no drag, 1 horizental, 2 vertical, 3 either, default value is 1 (Note that the $DragOrientation should be the same as $PlayOrientation when $DisplayPieces is greater than 1, or parking position is not 0)
                $ArrowNavigatorOptions: {
                    //[Optional] Options to specify and enable arrow navigator or not
                    $Class: $JssorArrowNavigator$, //[Requried] Class to create arrow navigator instance
                    $CaptionTransitions: _CaptionTransitions,
                    $ChanceToShow: 2, //[Required] 0 Never, 1 Mouse Over, 2 Always
                    $AutoCenter: 0 //[Optional] Auto center arrows in parent container, 0 No, 1 Horizontal, 2 Vertical, 3 Both, default value is 0
                },
                $AutoPlay: true
            }

            $(".slider_container_wrapper > .slider_container").each(function(index) {
                var elem_id = $(this).attr("id")

                var jssor_slider1 = new $JssorSlider$(elem_id, options)

                var width = $(this)
                    .parent()
                    .width()

                jssor_slider1.$SetScaleWidth(width)
            })
        })
    }

    $(".wdka_gallery_capture")
        .parent()
        .mouseenter(function() {
            $(this)
                .children(".wdka_gallery_capture")
                .slideDown()
        })
    $(".wdka_gallery_capture")
        .parent()
        .mouseleave(function() {
            $(this)
                .children(".wdka_gallery_capture")
                .slideUp()
        })


    $(".post_comment").on("click", function() {
        //prepare the editor to get the data
        tinyMCE.triggerSave(false, true)

        //get params
        var content_editor = $("#wdka_comment_editor").val()
        var post_id = $(this).attr("attr-post-id")
        var blog_id = $(this).attr("attr-blog-id")
        var this_elem = $(this)

        $.post("wp-content/themes/wdka-master/js/ajax/post-comment.php", {
            content_editor: content_editor,
            post_id: post_id,
            blog_id: blog_id
        }).done(function(data) {
            //when completed, a json will return
            var obj_comment = $.parseJSON(data)

            var d = new Date()
            var m = d.getMilliseconds()

            //prepare
            var ret = ""

            //append to top of the wrapper
            ret +=
                "<div class='master-block-two master-font_12 master-block-main_content fadein zoomer_" +
                m +
                "' style='display: none;'>"
            ret += "    <div class='inner'>"
            ret +=
                "        <div><b>" +
                obj_comment.author +
                " wrote on " +
                obj_comment.date +
                "</b></div>"
            ret +=
                "        <img src='" +
                url +
                "/wp-content/themes/wdka-master/img/icons/delete_icon.png' alt='' class='delete_comment' attr-blog-id='" +
                blog_id +
                "' attr-comment-id='" +
                obj_comment.id +
                "'  />"
            ret +=
                "        <img src='" +
                url +
                "/wp-content/themes/wdka-master/img/icons/edit_icon.png' alt='' class='edit_comment' attr-comment-editor='" +
                m +
                "_editor' attr-blog-id='" +
                blog_id +
                "' attr-comment-id='" +
                obj_comment.id +
                "'  />"
            ret += "        <div class='comment_content'>"
            ret += obj_comment.content
            ret += "        </div>"
            ret += "        <div class='comment_editor'>"
            ret += "        </div>"

            ret += "    </div>"
            ret += "</div>"

            $(".comments_wrapper").prepend(ret)
            $(".fadein").slideDown()
            $(".comment_editor_wrapper").slideUp()

            var current_comments = $(".comments_num").html()
            var int_current_comments = parseInt(current_comments)
            $(".comments_num").html(int_current_comments + 1)

            init_slider()

            // var cont = $(".zoomer_" + m).find(
            //     ".wdka_gallery_image_wrapper_highres_image"
            // )

            // init_highres_image(cont)
        })
    })

    $(".comment_editor_slidedown").click(function() {
        $(".comment_editor_wrapper").slideToggle()
        tinymce.execCommand("mceFocus", false, "wp-wdka_comment_editor-editor")
    })

    $("body").on("click", ".delete_comment", function() {
        if (confirm("are you sure you want to delete this comment?")) {
            //init
            var this_elem = $(this)

            //get params
            var comment_id = $(this).attr("attr-comment-id")
            var blog_id = $(this).attr("attr-blog-id")

            //do ajax call
            $.post("wp-content/themes/wdka-master/js/ajax/delete-comment.php", {
                comment_id: comment_id,
                blog_id: blog_id
            }).done(function(data) {
                if (data == "1") {
                    this_elem
                        .parent()
                        .parent()
                        .slideUp(function() {
                            $(this).remove()
                        })
                }
            })

            //update the comments number
            var current = $(".comments_num").html()
            var new_current = current - 1
            $(".comments_num").html(new_current)
        }
    })

    $("body").on("click", ".edit_comment", function() {
        //init
        var this_elem = $(this)

        //get params
        var comment_id = $(this).attr("attr-comment-id")
        var blog_id = $(this).attr("attr-blog-id")
        var editor_id = $(this).attr("attr-comment-editor")

        //do ajax call
        $.post("wp-content/themes/wdka-master/js/ajax/get_editor.php", {
            comment_id: comment_id,
            blog_id: blog_id,
            editor_id: editor_id
        }).done(function(data) {
            //remove old content
            this_elem.next(".comment_content").slideUp()

            this_elem
                .next()
                .next()
                .html(data)
                .slideDown()

            tinymce.execCommand("mceRemoveEditor", true, editor_id)
            tinymce.execCommand("mceAddEditor", false, editor_id)
            var init = tinymce.extend({}, tinyMCEPreInit.mceInit[editor_id])
        })
    })

    $("body").on("click", ".comment_edit_button", function() {
        tinyMCE.triggerSave(false, true)

        var this_elem = $(this)
        var val = $(this)
            .parent()
            .find(".wp-editor-area")
            .val()
        var comment_id = $(this).attr("attr-comment-id")
        var blog_id = $(this).attr("attr-blog-id")

        $.post("wp-content/themes/wdka-master/js/ajax/edit_comment.php", {
            comment_id: comment_id,
            blog_id: blog_id,
            val: val
        }).done(function(data) {
            var obj = $.parseJSON(data)

            this_elem
                .parent()
                .prev()
                .html(obj.content)
                .slideDown(function() {
                    this_elem.parent().slideUp(function() {
                        this_elem.parent().html("")
                    })
                })
        })
    })

    //navigation and settings buttons needs to be stattic at a point
    if ($(".master-metablock").length > 0) {
        scrollable_metablock()
    }

    $(window).resize(function() {
        if ($(".master-metablock").length > 0) {
            scrollable_metablock()
        }
    })

    function scrollable_metablock() {
        if ($(window).width() > 1005) {
            //add magnet class
            var magneticMeta = $(".master-metablock")
            if (!magneticMeta.hasClass('no-magnet')) {
                magneticMeta.addClass("master-magnetic-meta")
            } else {
                return
            }


            //get current position
            var metablock_pos = $(".master-magnetic-meta").position()
            var meta_left = metablock_pos.left

            $(window).scroll(function() {
                clearTimeout($.data(this, "scrollTimer"))
                $.data(
                    this,
                    "scrollTimer",
                    setTimeout(function() {
                        var meta_top = window.pageYOffset

                        //animate block to the right position
                        $(".master-magnetic-meta")
                            .css("position", "absolute")
                            .animate({
                                left: meta_left,
                                top: meta_top,
                                duration: 1000
                            })
                    }, 250)
                )
            })
        } else {
            $(".master-metablock")
                .removeClass("master-magnetic-meta")
                .css("top", "auto")
        }
    }



    function nl2br(str, is_xhtml) {
        var breakTag =
            is_xhtml || typeof is_xhtml === "undefined" ? "<br />" : "<br>"
        return (str + "").replace(
            /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
            "$1" + breakTag + "$2"
        )
    }


    $(".show_filter").on("click", function() {
        //get values
        var section = $(this).attr("attr-section")
        var blog_id = $(this).attr("attr-blog-id")
        var value = $(this).is(":checked")
        var element = "filter"
        var this_elem = $(this)

        //update blog settings
        $.post(
            "wp-content/themes/wdka-master/js/ajax/update_wp_blog_settings.php", {
                section: section,
                blog_id: blog_id,
                value: value,
                element: element
            }
        ).done(function(data) {
            if (data !== "") {
                //give error
                console.log("error" + data)
            } else {
                //reload to see changes
                blog_settings_saved()
            }
        })
    })

    //on keyup, start the countdown
    var timer
    var x
    $(".wdka_update_blog_setting").keyup(function(e) {
        var keyCode = e.keyCode || e.which
        if (keyCode == 9) {
            return
        }

        clearTimeout(timer)
        var this_elem = $(this)

        timer = setTimeout(function() {
            //get req var
            var blog_id = this_elem.attr("attr-blog-id")
            var setting_key = this_elem.attr("attr-setting-key")
            var setting_value = this_elem.val()

            //wait a short time
            $.post(
                "wp-content/themes/wdka-master/js/ajax/wdka_update_blog_setting.php", {
                    blog_id: blog_id,
                    setting_key: setting_key,
                    setting_value: setting_value
                }
            ).done(function(data) {
                if (data !== "") {
                    //get required params
                } else {
                    this_elem
                        .parent()
                        .find(".confirm")
                        .html("<b>&#8730;</b>")

                    //if the blog color is updated, we should update the front-end realtime
                    if (setting_key == "wdka_blog_color") {
                        $("#master-bloginfo").css("background-color", setting_value)
                    }

                    //change blog title real time
                    if (setting_key == "wdka_blog_title") {
                        $("#wdka_blog_title").html(setting_value)
                    }
                    if (setting_key == "wdka_blog_subtitle") {
                        $("#wdka_blog_sub_title").html(setting_value)
                    }
                }
            })
        }, 500)
    })

    $(".wdka_close_blog_settings").on("click", function() {
        $.fancybox.close()
    })

    $("#favourite").on('click', function(e) {
        e.preventDefault()
        var action = $(this).data('action')
        var blog_id = $(this).data('blog_id')
        var user_hroid = $(this).data('user_hroid')
        var ajax_url = "wp-content/themes/wdka-master/js/ajax/do.php"

        switch (action) {
            case 'add':
                $.post(
                    ajax_url, {
                        sk: true,
                        action: "addFavourite",
                        blog_id: blog_id,
                        user_hroid: user_hroid
                    },
                    function(data) {
                        var returnValue = JSON.parse(data)
                        if (returnValue.success) {
                            $(this).html("Remove from Favourites").data('action', 'remove')
                        }
                    }.bind(this)
                )
                break;
            case 'remove':
                $.post(
                    ajax_url, {
                        sk: true,
                        action: "removeFavourite",
                        blog_id: blog_id,
                        user_hroid: user_hroid
                    },
                    function(data) {
                        returnValue = JSON.parse(data)
                        if (returnValue.success) {
                            $(this).html("Add to Favourites").data('action', 'add')
                        }
                    }.bind(this)
                )
                break;
        }

    })


    var modalAssign = {
        message: "You are about to take upon you the role of editor of this site, this will allow you to edit and add content. The site admin(s) will be notified.",
        buttonText: "I understand, I want to contribute",
        action: function() {
            var returnValue = null
            $.post("wp-content/themes/wdka-master/js/ajax/do.php", {
                    sk: true,
                    action: "addUserRole"
                })
                .done(function(data) {
                    returnValue = JSON.parse(data)

                    if (returnValue.success) {
                        window.setTimeout(function() {
                            $("#modal").hide()
                        }, 3500)
                        $("#modal")
                            .find(".message")
                            .addClass("success")
                            .html(returnValue.message)
                            .siblings(".button-container")
                            .hide()
                        $("#assign-role").hide()
                    }
                })
                .fail(function(xhr) {
                    $("#modal")
                        .find(".message")
                        .addClass("error")
                        .html("error: " + xhr.responseText)
                        .siblings(".button-container")
                        .toggle()
                })
        }
    }

    $("#assign-role").modal(modalAssign)

    $(".expand-author-list").click(function(e) {
        e.preventDefault();
        $(this)
            .toggleClass('hide')
            .next('.expanded-list')
            .slideDown(67);

    })


    function message(message, delay = 1500, complete = null) {
        $('#message > .message-content').html(message)
        $('#message')
            .css({
                display: 'block'
            })
            .animate({
                'opacity': 1
            })
            .delay(delay)
            .animate({
                'opacity': 0
            }, {
                complete: function() {
                    $(this).css({
                        display: 'none'
                    })
                    if (typeof complete === 'function') {
                        complete.call()
                    }
                }
            })
    }


    $('li.page_item_has_children > ul.children, li.menu-item-has-children > ul.sub-menu')
        .addClass('collapsed')
        .parent()
        .prepend(`<div class="expand"></div> `)
        .on('click', '>.expand', function(e) {
            var expand = $(e.target)
            expand
                .toggleClass('clicked')
                .parent()
                .find('>ul.children, >ul.sub-menu')
                .slideToggle(200)
        })



    $('.cat-item > ul.children')
        .addClass('collapsed')
        .parent()
        .prepend(`<div class="expand"></div> `)
        .on('click', '>.expand', function(e) {
            var expand = $(e.target)
            expand
                .toggleClass('clicked')
                .parent()
                .find('>ul.children, >ul.sub-menu')
                .slideToggle(200)
        })

    $('.current_page_parent>.expand, .current_page_ancestor > .expand, .current_page_item>.expand, li.current-cat-ancestor>.expand').addClass('clicked')
})


// WEBPACK FOOTER //
// ./js/main-source.js